import { css } from "styled-components";
import { Carousel, CarouselSlide, CarouselViewport, CarouselSlides, CarouselProgressBar, CarouselControls, } from "../../../../components/Carousel";
import { BladeHeader, BladeHeaderBody, BladeHeaderSupertitle, BladeHeaderTitle, } from "../../../../components/BladeHeader";
import { textUppercaseMixin } from "../../../../skins/shared/mixins/typography";
export const riotProductSkin = (chroma, paletteTokens) => css `
  & {
    /* example base styles using theme object values */
    background-color: ${paletteTokens.bladebg1};
    position: relative;
    padding: ${chroma.spacers.bladeEdge.top} 0 ${chroma.spacers.bladeEdge.bottom};
  }

  .body {
    padding: ${chroma.spacers.variable.l};
    padding-top: 0;
    font-size: 16px;
  }

  /****  BACKDROPS  ***/
  .backdrop {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
  }

  .icon-tab--backdrop-main {
    width: 100%;
    height: 100%;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }

  .icon-tab--backdrop-full-foreground {
    width: 100%;
    height: 100%;
    top: 0;

    img {
      object-position: center center;
      object-fit: contain;
      width: 100%;
      height: 100%;
    }

    z-index: 1;
  }

  .icon-tab--backdrop-full-background {
    width: 100%;
    height: 100%;
    top: 0;

    img {
      object-position: center center;
      object-fit: cover;
      width: 100%;
      height: 100%;
    }

    z-index: 1;
  }

  .icon-tab--backdrop-item {
    width: 100%;
    height: 100%;

    .icon-tab--backdrop-item-foreground {
      top: 0;
    }

    img {
      width: 100%;
      object-fit: contain;
      object-position: center center;
    }
  }

  /****  BACKDROPS  ***/

  .icon-tab--container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: "tabs media";
    align-items: flex-start;
    gap: ${chroma.spacers.variable.m};
    justify-content: center;
    ${chroma.mediaQueries.tabletDown} {
      grid-template-columns: 1fr;
      grid-template-rows: auto auto;
      grid-template-areas:
        "tabs"
        "media";
    }
  }

  .icon-tab--main {
    grid-area: tabs;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
  }

  /****  TABS  ***/
  .icon-tab--tabs {
    z-index: 1;
  }

  .icon-tab-tab {
    display: flex;
    justify-content: center;
    transition: transform 300ms;
    cursor: pointer;
    flex-direction: column;
    text-align: center;

    &.tab--inactive {
      filter: brightness(50%);

      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .icon-tab-label {
    ${chroma.typography.body5}
    ${textUppercaseMixin}
    word-break: normal;
    font-weight: 600;
    color: ${paletteTokens.bladetext1};
    margin-top: ${chroma.spacers.constant.s};
  }

  .icon-tab-header-link-cta {
    cursor: pointer;
  }

  /****  END TABS  ***/

  /****  HEADER  ***/

  ${BladeHeader} {
    grid-area: header;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    z-index: 1;
  }

  ${BladeHeaderSupertitle} {
    ${chroma.typography.body2}
    color: ${paletteTokens.bladetext1};
    font-weight: 500;
    margin-bottom: ${chroma.spacers.variable.xs};
  }

  ${BladeHeaderTitle} > h2 {
    ${chroma.typography.display3}
    color: ${paletteTokens.bladetext1};
    margin-bottom: ${chroma.spacers.variable.sm};
  }

  ${BladeHeaderBody} {
    ${chroma.typography.body3}
    color: ${paletteTokens.bladetext1};
    margin-bottom: ${chroma.spacers.variable.l};
  }

  .icon-tab-header-centered-links {
    display: flex;
    gap: ${chroma.spacers.constant.s};
    width: 100%;
    margin-bottom: ${chroma.spacers.variable.l};
    justify-content: center;

    ${chroma.mediaQueries.tabletDown} {
      flex-direction: column;
      align-items: center;
    }
  }

  /****  END HEADER  ***/

  /****  MEDIA  ***/
  .icon-tab--media {
    grid-area: media;
    z-index: 1;
  }

  .icon-tab-media-position {
    margin-bottom: ${chroma.spacers.variable.l};
  }

  .icon-tab-media-media {
    padding: ${chroma.spacers.constant.sm};

    &.arNativeBordered {
      border: solid 1px ${paletteTokens.accents1};
    }

    &.roundBordered {
      border-radius: 50%;
      border: solid 1px ${paletteTokens.accents1};

      img,
      video {
        clip-path: circle(50%);
      }
    }
  }

  .icon-tab-media-content {
    text-align: center;
    position: relative;
  }

  .icon-tab-media-content-header {
    display: flex;
    justify-content: center;
    margin-bottom: ${chroma.spacers.variable.s};
  }

  .icon-tab-media-content-dot {
    display: flex;
    align-items: center;

    &::after {
      background-color: ${paletteTokens.accents1};
      display: block;
      content: "";
      height: 4px;
      width: 4px;
      transform: rotate(45deg);
    }
  }

  .icon-tab-media-supertitle {
    ${chroma.typography.display7}
    color: ${paletteTokens.bladetext1};
  }

  .icon-tab-media-title {
    ${chroma.typography.display7}
    color: ${paletteTokens.bladetext1};
  }

  .icon-tab-media-subtitle {
    ${chroma.typography.body4}
    font-weight: 600;
    color: ${paletteTokens.bladetext1_light};
    margin-bottom: ${chroma.spacers.variable.xxs};
    box-sizing: border-box;
  }

  .icon-tab-media-description,
  .icon-tab-media-description-hidden {
    ${chroma.typography.body3}
    color: ${paletteTokens.bladetext1};
  }

  .icon-tab-media-description-hidden {
    visibility: hidden;
    position: absolute;
    pointer-events: none;
  }

  /****  END MEDIA  ***/

  ${CarouselViewport} {
    .icon-tab-tab-img {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    ${CarouselSlides} {
      --carousel-gap: ${chroma.spacers.variable.l};

      display: flex;
      gap: var(--carousel-gap);
    }
  }

  ${Carousel} {
    &[data-state-all-slides-visible="true"] {
      ${CarouselControls} {
        display: none;
      }
      ${CarouselSlides} {
        justify-content: center;
      }
      ${CarouselSlide} {
        width: calc(((100% - (var(--carousel-gap) * var(--carousel-gap-count))) / (1 * var(--carousel-n-up))));
      }
    }
  }

  ${CarouselSlide} {
    --carousel-n-up: 6;
    --carousel-gap-count: calc(var(--carousel-n-up) - 1);
    --carousel-width: calc(((100% - (var(--carousel-gap) * var(--carousel-gap-count))) / (1 * var(--carousel-n-up))));

    ${chroma.mediaQueries.tabletDown} {
      --carousel-n-up: 6;
    }
    ${chroma.mediaQueries.mobileDown} {
      --carousel-n-up: 5;

      /* justify-content: flex-start; */

      /* This is to make sure that the carousel items are all the same size on Android mobile devices */
      max-width: var(--carousel-width);
      justify-content: center;
    }

    min-width: var(--carousel-width);
  }

  ${CarouselControls} {
    position: relative;
    margin: ${chroma.spacers.variable.l} 0;
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: ${chroma.spacers.constant.s};

    .trigger-wrapper {
      display: flex;
      gap: ${chroma.spacers.constant.xs};
      align-self: flex-end;

      button {
        margin: 0;
      }
    }

    ${CarouselProgressBar} {
      width: 100%;
      padding-right: 0;

      .indicator {
        transition: width 0.7s ease-out;
        background-color: ${paletteTokens.accents1};
        height: 4px;
      }

      .rail {
        margin-top: 0;
        width: 100%;
        background-color: ${paletteTokens.keyline};
      }

      flex-grow: 1;
      align-self: center;
      ${chroma.mediaQueries.mobileDown} {
        width: 100%;
      }
    }
  }
`;
//# sourceMappingURL=index.js.map